import { Option, TranslationFunction } from '@/types';

export const inputsVerifySSN = ($t: TranslationFunction): Option[] => [
  {
    value: 'kolliId',
    label: $t('kolliID')
  },
  {
    value: 'ssnVerify',
    label: $t('ssn')
  }
];

export const inputsSSN = ($t: TranslationFunction): Option[] => [
  {
    value: 'kolliId',
    label: $t('kolliID')
  },
  {
    value: 'ssn',
    label: $t('ssn')
  },
  {
    value: 'ssnForOtherPerson',
    label: $t('ssnForOtherPerson')
  }
];

export const inputsVerifyWithoutSSN = ($t: TranslationFunction): Option[] => [
  {
    value: 'kolliId',
    label: $t('kolliID')
  },
  {
    value: 'phoneNumber',
    label: $t('phoneNumber')
  },
  {
    value: 'pinCode',
    label: $t('pinCode')
  }
];
